import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import { states } from "../../../reducers/queriesStates";
import ReportConstructrSwitcher from "./ReportConstructrSwitcher";
import ReportConstructorPaternList from "./ReportConstructorPaternList";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import ReportContructorCustom from "./ReportContructorCustom";
import ReportConstructorCustomList from "./ReportConstructorCustomList";
import Preloader from "../../../shared/items/static/preloader";

class ReportContructor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPatternListOpen: true,
    };
  }

  componentDidMount() {
    const { reportsListDataState, onGetReportsList, selectedCustomReportId, onSelectedCustomReport } = this.props;

    if (reportsListDataState === states.NOT_REQUESTED) {
      onGetReportsList();
    }

    if (selectedCustomReportId === null) {
      const reportId = window.location.pathname.replace("/controls/reportConstructor/", "");
      if (!reportId.includes("reportConstructor")) {
        onSelectedCustomReport(reportId);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedCustomReportId } = this.props;

    if (prevProps.selectedCustomReportId !== null && selectedCustomReportId === null) {
      this.setState({ isPatternListOpen: false });
    }
  }

  onHandleSwithcer(isPatternListOpen) {
    this.setState({ isPatternListOpen });
  }

  render() {
    const { isPatternListOpen } = this.state;
    const { selectedCustomReportId, reportsListDataState } = this.props;

    return (
      <div className={styles.controlReportConstructorContainer}>
    
        {selectedCustomReportId === null ? (
          <div>
            <ReportConstructrSwitcher isPatternListOpen={isPatternListOpen} onChange={this.onHandleSwithcer.bind(this)} />
            {isPatternListOpen ? <ReportConstructorPaternList /> : <ReportConstructorCustomList />}
          </div>
        ) : (
          <ReportContructorCustom />
        )}
            {reportsListDataState === states.REQUEST ? <Preloader /> : null}
      </div>
    );
  }
}

export default withCustomReport(withReportsList(React.memo(ReportContructor)));
